import { useCallback } from 'react';
import { RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { AModal } from '../../../components';
import { IFinancial } from '../../../shared/interfaces';
import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { Alert, Typography, Divider } from 'antd';

interface IReverseProps {
  open: boolean;
  close: () => void;
  selectRows: IFinancial[];
  setSelectRows: React.Dispatch<React.SetStateAction<IFinancial[]>>;
  setFinancials: React.Dispatch<React.SetStateAction<IFinancial[]>>;
}

const FinancialReverse: React.FC<IReverseProps> = ({
  open,
  close,
  selectRows,
  setSelectRows,
  setFinancials,
}) => {
  const { addToast } = useToast();

  const handleEditSubmit = useCallback(async () => {
    try {
      const ids = selectRows.map((item) => String(item.id));

      const response = await api.patch(`/financials/reverse`, {
        ids,
        updated_by: '',
      });

      const updatedItems = response.data;
      setFinancials((prev) =>
        prev.map((item) => {
          const updated = updatedItems.find(
            (u: IFinancial) => u.id === item.id,
          );
          return updated || item;
        }),
      );

      addToast({
        type: 'success',
        title: 'Estornado',
        description: 'Lançamento(s) estornado(s) com sucesso.',
      });

      setSelectRows([]);
      close();
    } catch (error: any) {
      addToast({
        type: 'error',
        title: 'Erro',
        description:
          error.response?.data?.message || 'Erro ao realizar estorno',
      });
    }
  }, [selectRows, setFinancials, addToast, close, setSelectRows]);

  return (
    <AModal
      open={open}
      close={() => {
        setSelectRows([]);
        close();
      }}
      okText={'Confirmar Estorno'}
      cancelText={'Cancelar'}
      title={
        <>
          <RedoOutlined /> Estornar Lançamento(s)
        </>
      }
      onOk={handleEditSubmit}
      width={500}
    >
      <Alert
        message="Atenção"
        description={`Você está prestes a reverter o pagamento de ${selectRows.length} conta(s). Elas voltarão para o status "Pendente".`}
        type="warning"
        showIcon
        icon={<ExclamationCircleOutlined />}
      />

      <div style={{ marginTop: 16 }}>
        <Typography.Text strong>Contas selecionadas:</Typography.Text>
        <div
          style={{
            maxHeight: 150,
            overflowY: 'auto',
            marginTop: 8,
            background: '#fafafa',
            padding: 8,
            borderRadius: 4,
            border: '1px solid #f0f0f0',
          }}
        >
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {selectRows.map((item) => (
              <li key={item.id}>
                <Typography.Text type="secondary">{item.code}</Typography.Text>{' '}
                - {item.description}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AModal>
  );
};

export default FinancialReverse;
